﻿import "./LoginCallback.scss";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardContent, Button, Alert } from "../shared/components";
import { useAuth } from "./AuthContext";
import { useQueryParams } from "../shared/hooks";
import { useSettings } from "../shared/providers/SettingsProvider";
import { toRelativeUri } from "../shared/utilities";

export default function LoginCallback() {
    const { loginWithRedirect, error: _error } = useAuth();
    let error = _error;
    const query = useQueryParams();
    const originalPath: string | undefined = query.get("original-path");
    const settings = useSettings();
    const navigate = useNavigate();

    // Redirect to the original page after a prior unsuccessful login attempt, or the home page if we erroneously ended up here...
    if (!error) {
        try {
            navigate(
                toRelativeUri(originalPath ?? window.location.origin)
            );
            return null;
        }
        catch (ex: unknown) {
            error = ex instanceof Error ? ex.message : ex.toString();
        }
    }

    const accessDenied = error?.includes("not authorized");

    return (
        <Card className="screen-centered" style={{ maxWidth: "600px" }}>
            <CardHeader title={accessDenied ? "Access Denied" : "Login Failed"} />
            <CardContent className="text-align-center">
                {error}
                {
                    accessDenied &&
                    settings.owner &&
                    <Alert color="info" icon={false} className="margin-top-3 col-fill">
                        <div className="site-owner-details-grid">
                            <div className="field">Site Administrator</div>
                            <div className="value">{settings.owner.name}</div>

                            <div className="field">Email Address</div>
                            <div className="value">
                                <a href={`mailto:${settings.owner.emailAddress}&subject=Please grant me access to ${window.location.host}`}>{settings.owner.emailAddress}</a>
                            </div>
                        </div>
                    </Alert>
                }
                <Button variant="contained" color="primary" className="align-self-center margin-top-3" onClick={() => loginWithRedirect({ targetUrl: originalPath ?? window.location.origin })}>Try Again</Button>
            </CardContent>
        </Card>
    );
}